import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    AgreeDisagreeOptions,
    AnswerOptions,
    ClosedOptions,
    FiveStarsOptions,
    PollTarget,
    PollTemplate,
    PollUnderCreation,
    RecurrenceType,
    ScaleOptions,
    ScheduleOptions
} from './create-poll.type';
import { ScheduleOptionPreview } from './poll-preview/poll-preview.type';
import { EMPTY, firstValueFrom, map, Observable } from "rxjs";
import { format } from "date-fns";


@Injectable({
    providedIn: 'root'
 })
export class CreatePollService {

    constructor(private http: HttpClient) { }

    async createPoll(question: PollUnderCreation){
        let n =1;
        question.answerOptions.choices = question.answerOptions.choices.map(choice => {
            return {
                label: choice.label,
                position: n++,
            }
        })
        return await firstValueFrom(
            this.http.post<Promise<PollUnderCreation>>('/api/question/new', question)
        )
    }

    getPollTemplates(tags: string[]): Observable<PollTemplate[]>{
            if (tags.length > 0) {
                const params: HttpParams = tags.reduce((acc: HttpParams, current: string) => {
                    return acc.append('tags', current);
                }, new HttpParams())
                return this.http.get<PollTemplate[]>(`/api/question/templates`, {params: params});
            } else {
                return EMPTY;
            }
    }

    getTypedAnswerOptions(answerOptions: AnswerOptions) : AgreeDisagreeOptions | ScaleOptions | ClosedOptions | FiveStarsOptions {
        switch(answerOptions.type){
            case 'AgreeDisagreeQuestion':
                return answerOptions as AgreeDisagreeOptions;
            case 'ScaleQuestion':
                return answerOptions as ScaleOptions;
            case 'ClosedQuestion':
                return answerOptions as ClosedOptions;
            case 'FiveStarsQuestion':
                return answerOptions as FiveStarsOptions;
        }
    }

    async getScheduleOptions(options: ScheduleOptions): Promise<ScheduleOptionPreview>{
        return await firstValueFrom(this.http.put<ScheduleOptionPreview>('/api/question/schedule', options));
    }

    getRecurrenceOptions(start: Date, type: RecurrenceType){
        let optionValue;
        switch(type){
            case 'once':
                optionValue = null;
                break;
            case 'weekly':
                optionValue = format(start, 'iiii');
                break;
            case 'monthly':
                optionValue = format(start, 'd');
                break;
        }
        return {
            value: optionValue,
            type: type
        }
    }

    async getPollRecipients(teamIds: PollTarget): Promise<number>{
        return await firstValueFrom(
            this.http.put<{size: number}>('/api/question/target/size', {teamIds: teamIds}).pipe(
                map(result => {
                    return result.size
                })
            )
        );
    }
}



